import { database } from '../firebase/firebase';
import { ref, get, update, serverTimestamp, runTransaction } from 'firebase/database';
import { CMS_DATA_PATH, CMS_VERSIONS_PATH, CMS_UPDATED_AT_PATH, SectionKey } from './sections';

export async function fetchVersions(): Promise<Record<SectionKey, number>> {
  const snap = await get(ref(database, CMS_VERSIONS_PATH));
  const val = (snap.val() || {}) as Record<string, number>;
  // force numbers, unknowns -> 0
  return {
    whyChoose: Number(val.whyChoose || 0),
    reviews: Number(val.reviews || 0),
    parents: Number(val.parents || 0),
    news: Number(val.news || 0),
    mealsWeek1: Number(val.mealsWeek1 || 0),
    mealsWeek2: Number(val.mealsWeek2 || 0),
    forms: Number(val.forms || 0),
    fees: Number(val.fees || 0),
    features: Number(val.features || 0),
    about: Number(val.about || 0),
  };
}

export async function fetchSection<T>(section: SectionKey): Promise<T | null> {
  const snap = await get(ref(database, CMS_DATA_PATH[section]));
  return (snap.exists() ? (snap.val() as T) : null);
}

/*
// Dirty-check save:
// - expectedVersion must match current; otherwise throw {code:'STALE_VERSION'}
export async function saveSection<T>(section: SectionKey, payload: T, expectedVersion: number): Promise<number> {
  // 1) bump version via transaction
  const verRef = ref(database, `${CMS_VERSIONS_PATH}/${section}`);
  const txRes = await runTransaction(verRef, (current) => {
    const curr = Number(current || 0);
    if (curr !== expectedVersion) {
      // returning undefined keeps current value and marks committed=false
      return;
    }
    return curr + 1;
  });

  if (!txRes.committed) {
    const current = Number(txRes.snapshot?.val() || 0);
    const err = new Error(`Stale version: expected ${expectedVersion}, got ${current}`) as any;
    err.code = 'STALE_VERSION';
    err.current = current;
    throw err;
  }

  const newVersion = Number(txRes.snapshot?.val() || expectedVersion + 1);

  // 2) write payload and timestamp
  await update(ref(database), {
    [CMS_DATA_PATH[section]]: payload,
    [`${CMS_UPDATED_AT_PATH}/${section}`]: serverTimestamp(),
  });

  return newVersion;
}
*/

export async function saveSection<T>(section: SectionKey, payload: T, expectedVersion?: number): Promise<number> {
  const verRef = ref(database, `${CMS_VERSIONS_PATH}/${section}`);

  // Always bump version regardless of expectedVersion
  const txRes = await runTransaction(verRef, (current) => Number(current || 0) + 1);
  const newVersion = Number(txRes.snapshot?.val() || 0);

  await update(ref(database), {
    [CMS_DATA_PATH[section]]: payload,
    [`${CMS_UPDATED_AT_PATH}/${section}`]: serverTimestamp(),
  });

  return newVersion;
}
